// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"664":"ede85ee7","724":"ede85ee7"}[chunkId] + ".chunk.css";
};